<app-header></app-header>
<div class="body-container clearfix">
    <div class="row">
        <div class="col-12 box">
            <div class="col-12 box-title">
                Please upload your license!
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-6 box">
            <div class="box-child clearfix">
                <div class="photo-container">
                    <label for="fileFront">
                        <i *ngIf="!backImage.file" class="fas fa-camera-retro"></i>
                        <div *ngIf="!frontImage.file" class="photo-title">
                            Add Front of Driver’s License
                        </div>
                        <img *ngIf="frontImage.file" [src]="frontImage.file.data">
                    </label>
                    <input type="file" id="fileFront" name="fileFront" (change)="fileChangeEvent($event, true)">
                </div>
            </div>
        </div>
        <div class="col-6 box">
            <div class="box-child clearfix">
                <div class="photo-container">
                    <label for="fileBack">
                        <i *ngIf="!backImage.file" class="fas fa-camera-retro"></i>
                        <div *ngIf="!backImage.file" class="photo-title">
                            Add Back of Driver’s License
                        </div>
                        <img *ngIf="backImage.file" [src]="backImage.file.data">
                    </label>
                    <input type="file" id="fileBack" name="fileBack" (change)="fileChangeEvent($event, false)">
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12 text-center">
            <button type="button" class="btn btn-primary" (click)="onContinueClick();" [disabled]="!frontImage.file || !backImage.file">UPLOAD LICENSE</button>
        </div>
    </div>
    <app-error-dialog [modalId]="errorId" [title]="errorTitle" [messageA]="errorMessageA" [messageB]="errorMessageB"
        [messageC]="errorMessageC" [messageBClass]="errorMessageBClass" [dialogClass]="dialogClass" (closeModal)="onCloseModal();">
    </app-error-dialog>
</div>
<app-footer></app-footer>